import React from "react";

// サステナブルマークの画像プレビューパネルの描画をまとめる。
// 本文は HinbanMaster.js から移設したもの。

export function createSustainablePreviewRenderer(deps) {
    const {
        commitSustainableImageFileName,
        entrydataRef,
        entrylock,
        handleSustainableImageFileNameKeyDown,
        layoutlock,
        noimage,
        readSustainableImageFileName,
        sectionBodyLocked,
        setSustainableImageFileInputValue,
        startSustainableImageFileNameEdit,
        sustainableImageFileEditing,
        sustainableImageFileInputValue,
        sustainableServerImageUrl
    } = deps;

    function renderSustainablePreviewPanel(panelInfo) {
        const locked = entrylock || layoutlock || sectionBodyLocked(panelInfo);
        const cellClassName = locked
            ? "hinban-sustainable-cell hinban-sustainable-cell--locked"
            : "hinban-sustainable-cell";
        const src = sustainableServerImageUrl === "" ? noimage : sustainableServerImageUrl;
        const fileName = readSustainableImageFileName(entrydataRef.current);
        const title = locked
            ? fileName
            : (fileName === ""
                ? "クリックしてサステナブルマーク画像ファイル名を入力"
                : `クリックしてサステナブルマーク画像ファイル名を入力: ${fileName}`);
        return (
            <div className="hinban-sustainable-panel">
                <div className={cellClassName} title={title} onClick={(event) => startSustainableImageFileNameEdit(panelInfo, event)}>
                    {sustainableImageFileEditing && !locked ? (
                        <div className="hinban-sustainable-editor" title={title} onClick={(event) => event.stopPropagation()}>
                            <input
                                type="text"
                                value={sustainableImageFileInputValue}
                                className="hinban-sustainable-filename-input"
                                autoFocus
                                onClick={(event) => event.stopPropagation()}
                                onChange={(event) => setSustainableImageFileInputValue(event.target.value)}
                                onBlur={commitSustainableImageFileName}
                                onKeyDown={handleSustainableImageFileNameKeyDown}
                            />
                        </div>
                    ) : (
                        <div className="hinban-sustainable-image-wrap">
                            <img src={src} alt="" className="hinban-sustainable-image" />
                        </div>
                    )}
                </div>
            </div>
        );
    }

    return {
        renderSustainablePreviewPanel
    };
}
